module.exports = __webpack_public_path__ + "img/zx_grey.ca56708b.png";